'use client';

import { authClient } from '@/lib';

import BugReportForm from '@/components/bug-report-form';
import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from '@/components/ui/dialog';
import { Bug } from 'lucide-react';
import * as React from 'react';

export default function BugReportDialogFloating() {
    const { data: session, isPending } = authClient.useSession();
    const [open, setOpen] = React.useState(false);

    // Don't show while loading or if user is authenticated
    if (isPending || session?.user) return null;

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <Button
                    size="icon"
                    className="fixed bottom-6 right-6 z-50 rounded-full shadow-lg bg-primary hover:bg-primary/90"
                    aria-label="Report a bug"
                >
                    <Bug className="size-5 text-white" />
                </Button>
            </DialogTrigger>

            <DialogContent className="max-w-2xl sm:max-w-3xl overflow-y-auto max-h-[90vh]">
                <DialogHeader>
                    <DialogTitle>Report a Bug or Request</DialogTitle>
                    <DialogDescription>
                        Describe what went wrong or what can be improved.
                    </DialogDescription>
                </DialogHeader>

                <BugReportForm onSubmitted={() => setOpen(false)} />
            </DialogContent>
        </Dialog>
    );
}
